<div style="display: flex">
  <div nz-dropdown nzTrigger="click" class="dropdown" [nzDropdownMenu]="menuAlerts" [(nzVisible)]="dropdownVisible">
    <nz-badge [nzCount]="badgeCount">
      <i class="icon fe fe-bell"></i>
    </nz-badge>
  </div>
  <nz-dropdown-menu #menuAlerts="nzDropdownMenu">
    <nz-card class="boxShadow">
      <nz-tabset class="tabs" [nzSelectedIndex]="0">
        <nz-tab nzTitle="Notificaciones">
          <div class="text-gray-6">
            <ul class="list-unstyled">
              <li class="mb-3" *ngFor="let item of notificationList | slice:0:6;" (click)="viewNotifications(item)">
                <div class="head">
                  <p class="title">
                    <strong class="text-black">{{item.title}}</strong>
                  </p>
                  <time class="time" [ngClass]="(item.status === false)?'unredMessages':'time'">{{item.issueDate}}</time>
                  <i *ngIf="!item.status" class="icon unredMessages fe fe-bell"></i>
                </div>
                <p>{{item.description}}</p>
              </li>
            </ul>
          </div>
        </nz-tab>
      </nz-tabset>
      <div class="mt-2" *ngIf="notificationList?.length > 0">
        <button class="m-2" nz-button nzType="default" (click)="viewAllNotifications()">Ver todas las
          notificaciones</button>
      </div>
    </nz-card>
  </nz-dropdown-menu>
</div>